import addWindowScrollPositionToDocument from './modules/viewport';
import initMenuToggle from './modules/menu-toggle';
import initLottie from './modules/lottie';
import swiper from './modules/swiper';
import initHomeTransition from './modules/home-transition';
import initCloseAlert from './modules/close-alert';
import initCookieConsent from './modules/cookie-consent';

addWindowScrollPositionToDocument();
initHomeTransition();
initMenuToggle();
initLottie();
initCookieConsent();
initCloseAlert();
swiper.crossLink();
